<!-- <div class="conatiner-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card" style="padding: 10px;">
                <h3><b>Account List</b></h3>
            </div>
        </div>
    </div>
<div class="card">
    <div class="row d-flex justify-content-end" *ngIf="!editmode">
        <button class="btn btn-sm btn-dark mr-4 mt-3" (click)="edit()">Edit TOS</button>
        <button class="btn btn-sm btn-dark mr-4 mt-3" (click)="edits()">Edit Active / Inactive</button>
    </div>
    <br>
    <div class="row d-flex justify-content-end" *ngIf="editmode">
        <div>
            <input type="text" name="" id="" [(ngModel)]="old_total_out_standing" class="form-control">
        </div>
        <div>
            <input type="text" name="" id="" [(ngModel)]="new_total_out_standing" class="form-control">
        </div>
        <div>
            <button class="btn btn-sm btn-dark ml-1 mr-4" (click)="update()">Update TOS</button>
        </div>
        <div>
            <button class="btn btn-sm btn-danger mr-4" (click)="cancel()">Cancel</button>
        </div>
    </div>
    <br>
    <div class="row d-flex justify-content-end" *ngIf="editmodes">
        <div>
            <select [(ngModel)]="account_status" class="form-control">
                <option value="">Choose</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
            </select>
        </div>
        <div>
            <button class="btn btn-sm btn-dark ml-1 mr-4" (click)="updates()">Update Active / Inactive</button>
        </div>
        <div>
            <button class="btn btn-sm btn-danger mr-4" (click)="cancel()">Cancel</button>
        </div>
    </div>

</div>

    <br>
    <div class="row">
        <div class="col-3">
            <div class="card" style="padding: 10px;">
                <h3>Filters</h3> -->
                <!-- <label for="">Account Status</label>
                <select [(ngModel)]="actives" class="form-control" (change)="getactives($event)">
                    <option value="">Choose</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                </select>
                <label for="">Allocation Status</label>
                <select [(ngModel)]="allocations" class="form-control" (change)="getallocations($event)">
                    <option value="Not Allocated">Not Allocated</option>
                    <option value="Allocated">Allocated</option>
                </select>
                <label for="">Bank Name</label>
                <select [(ngModel)]="bank_id" class="form-control"  (change)="fetchuser_1()">
                    <option value="">Choose</option>
                    <option *ngFor="let item of origianl_bank_list" [value]="item._id" >{{item.bank_name}}</option>
                </select> -->
                <!-- <label for="finterstalId">finterstal_id</label>
                <input type="text" [(ngModel)]="finterstal_id" (input)="filterFinterstalIdList(finterstal_id)" class="form-control" placeholder="Search">

                <select class="form-control"  [(ngModel)]="finterstal_id">
                  <option value="">Choose</option>
                  <ng-container *ngIf="finterstal_id === undefined || finterstal_id.length === 0; else filteredOptions">
                    <option *ngFor="let item of finterstal_id_list" [value]="item.finterstal_id">{{item.finterstal_id}}</option>
                  </ng-container>
                  <ng-template #filteredOptions>
                    <option *ngFor="let item of filteredFinterstalIdList" [value]="item.finterstal_id">{{item.finterstal_id}}</option>
                  </ng-template>
                </select>
                <div class="row d-flex justify-content-end">
                    <button class="btn btn-sm btn-dark mr-4" (click)="getINC()">Load Details</button>
                </div>
            </div>
        </div>
        <div class="col-3" *ngIf="!loading">
            <div class="animate">

            </div>
            <div>
                <p style="color: red;">Please Select Finterstal ID ...</p>
            </div>
        </div>
        <div class="col-3" *ngIf="Myloading">
            <div class="animate">

            </div>
            <div>
                <p style="color: red;">Loading Customer Accounts...</p>
            </div>
        </div>
        <div class="col-3" *ngIf="nO_DATA">
            <div>
                <p style="color: red;">No Data Found ...</p>
            </div>
        </div>
        <div class="col-9" *ngIf="!nO_DATA">
            <ag-grid-angular #agGrid
                    style="width: auto; height: 200px;"
                    class="ag-theme-alpine"
                    [rowData]="accountList"
                    [rowSelection]="'multiple'"
                    [columnDefs]="accountListcolumnDefs"
                    [pagination]="true">
            </ag-grid-angular>
        </div>
    </div>
</div> -->



<div class="conatiner-fluid">
  <div class="row">
      <div class="col-12">
          <div class="card" style="padding: 10px;">
              <h3><b>Account List</b></h3>
          </div>
      </div>
  </div>
<div class="card">
  <div class="row d-flex justify-content-end" *ngIf="!editmode">
      <button class="btn btn-sm btn-dark mr-4 mt-3" (click)="edit()">Edit TOS</button>
      <button class="btn btn-sm btn-dark mr-4 mt-3" (click)="edits()">Edit Active / Inactive</button>
  </div>
  <br>
  <div class="row d-flex justify-content-end" *ngIf="editmode">
      <div>
          <input type="text" name="" id="" [(ngModel)]="old_total_out_standing" class="form-control">
      </div>
      <div>
          <input type="text" name="" id="" [(ngModel)]="new_total_out_standing" class="form-control">
      </div>
      <div>
          <button class="btn btn-sm btn-dark ml-1 mr-4" (click)="update()">Update TOS</button>
      </div>
      <div>
          <button class="btn btn-sm btn-danger mr-4" (click)="cancel()">Cancel</button>
      </div>
  </div>
  <br>
  <div class="row d-flex justify-content-end" *ngIf="editmodes">
      <div>
          <select [(ngModel)]="account_statuss" class="form-control">
              <option value="">Choose</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
          </select>
      </div>
      <div>
          <button class="btn btn-sm btn-dark ml-1 mr-4" (click)="updates()">Update Active / Inactive</button>
      </div>
      <div>
          <button class="btn btn-sm btn-danger mr-4" (click)="cancel()">Cancel</button>
      </div>
  </div>

</div>

  <br>
  <div class="row">
      <div class="col-3">
          <div class="card" style="padding: 10px;">
              <h3>Filters</h3>
              <!-- <label for="">Account Status</label>
              <select [(ngModel)]="actives" class="form-control" (change)="getactives($event)">
                  <option value="">Choose</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
              </select>
              <label for="">Allocation Status</label>
              <select [(ngModel)]="allocations" class="form-control" (change)="getallocations($event)">
                  <option value="Not Allocated">Not Allocated</option>
                  <option value="Allocated">Allocated</option>
              </select>-->
              <!-- <label for="">Bank Name</label>
              <select [(ngModel)]="bank_id" class="form-control"  (change)="finterstal_id_get()">
                  <option value="">Choose</option>
                  <option *ngFor="let item of origianl_bank_list" [value]="item._id" >{{item.bank_name}}</option>
              </select>
              <label for="finterstalId">finterstal_id</label>
              <input type="text" [(ngModel)]="finterstal_id" (input)="filterFinterstalIdList(finterstal_id)" class="form-control" placeholder="Search">

              <select class="form-control"  [(ngModel)]="finterstal_id">
                <option value="">Choose</option>
                <ng-container *ngIf="finterstal_id === undefined || finterstal_id.length === 0; else filteredOptions">
                  <option *ngFor="let item of finterstal_id_list" [value]="item">{{item}}</option>
                </ng-container>
                <ng-template #filteredOptions>
                  <option *ngFor="let item of filteredFinterstalIdList" [value]="item">{{item}}</option>
                </ng-template>
              </select> -->

              <form [formGroup]="finterstal_idForm">
              <label for="finterstalId">Enter FINT ID...</label>
              <input type="text" formControlName="finterstal_id" class="form-control" placeholder="Search" required>

              <div class="row d-flex justify-content-end">
                  <button class="btn btn-sm btn-dark mr-4" (click)="getINC()">Load Details</button>
              </div>
            </form>
          </div>
      </div>
      <!-- <div class="col-3" *ngIf="!loading">
          <div class="animate">

          </div>
          <div>
              <p style="color: red;">Please Select Finterstal ID ...</p>
          </div>
      </div>
      <div class="col-3" *ngIf="Myloading">
          <div class="animate">

          </div>
          <div>
              <p style="color: red;">Loading Customer Accounts...</p>
          </div>
      </div>
      <div class="col-3" *ngIf="nO_DATA">
          <div>
              <p style="color: red;">No Data Found ...</p>
          </div>
      </div> -->
      <div class="col-9" *ngIf="!nO_DATA">
          <ag-grid-angular #agGrid
                  style="width: auto; height: 200px;"
                  class="ag-theme-alpine"
                  [rowData]="accountList"
                  [rowSelection]="'multiple'"
                  [columnDefs]="accountListcolumnDefs"
                  [pagination]="true">
          </ag-grid-angular>
      </div>
  </div>
</div>
